module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value[1] || _vm.value[0]),
      expression: "value[1] || value[0]"
    }],
    staticClass: "col-form-label"
  }, [_vm._v("  " + _vm._s(_vm.value[0]) + " - " + _vm._s(_vm.value[1]) + "  \n        "), _c('i', {
    staticClass: "fa fa-remove",
    on: {
      "click": _vm.reset
    }
  })]), _vm._v(" "), _c('dropdown-confirmation', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.value[0] && !_vm.value[1]),
      expression: "!value[0] && !value[1]"
    }],
    attrs: {
      "name": "latest_comms_filter",
      "size": "lg",
      "direction": "right",
      "styleObj": _vm.styleObj,
      "triggerBtnClass": "btn-clear",
      "triggerBtnHtml": "<i class=\"fa fa-sliders\"></i>",
      "confirmBtnClass": "btn-primary",
      "confirmBtnHtml": "<i class=\"fa fa-check\"></i>&nbsp;&nbsp;OK"
    },
    on: {
      "confirm": _vm.setValues
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "inline-input-holder"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.label == '$') ? _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.min),
      expression: "min",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Min",
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.min)
    },
    on: {
      "change": function($event) {
        _vm.min = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.label == '%') ? _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-percent"
  })]) : _vm._e()])]), _vm._v(" "), _c('span', [_vm._v("-  ")]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-holder"
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.label == '$') ? _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.max),
      expression: "max",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Max"
    },
    domProps: {
      "value": _vm._s(_vm.max)
    },
    on: {
      "change": function($event) {
        _vm.max = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.label == '%') ? _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-percent"
  })]) : _vm._e()])])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26bc2085!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/RangeFilter.vue
// module id = 372
// module chunks = 0